import React from 'react';
import {Image} from 'semantic-ui-react';

import {Table, Popup, PopupMessage, Icon} from '@components';
import constants from '@constants';
import utils from '@utils';
import mappings from '@mappings';
import {Props} from './types';

export const makeColumns = (
  props: Props,
  setIsPaging: React.Dispatch<React.SetStateAction<boolean>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => [
  {
    Header: () => {
      return (
        <Table.Sort
          value="名前"
          accessor="lastKana"
          updateCurrent={async (nextSort: string, current: number) => {
            setLoading(true);
            await props.actions.notifications.updateCurrentNotificationDetail({
              page: current,
              sort: nextSort,
              teamId: props.me.teamId,
              notificationId: props.match.params.id,
              isSafe: props.notifications.detail.search.isSafe,
              isMinorInjury: props.notifications.detail.search.isMinorInjury,
              isSeriousInjury:
                props.notifications.detail.search.isSeriousInjury,
              isAnswered: props.notifications.detail.search.isAnswered,
              name: props.notifications.detail.search.names,
              organization: props.notifications.detail.search.organizations,
              position: props.notifications.detail.search.positions,
            });
            setLoading(false);
          }}
          current={props.notifications.detail.pagination.current}
          currentSort={props.notifications.detail.pagination.sort}
        />
      );
    },
    accessor: 'lastKana',
    width: 160,
    Cell: ({cell}: {cell: any; column: any}) => {
      const detail = cell.row.original;

      return (
        <Table.Link
          to={`/users/detail/${detail.userId}`}
          value={`${detail.lastName} ${detail.firstName}`}
          detail={detail}
        />
      );
    },
  },
  {
    Header: '怪我',
    accessor: 'injuryStatus',
    width: 100,
    Cell: ({cell}: {cell: any; column: any}) => {
      return utils.mappings.getLabel(mappings.answers, cell.value);
    },
  },
  {
    Header: '回答状況',
    accessor: 'isAnswered',
    width: 120,
    Cell: ({cell}: {cell: any; column: any}) => {
      const detail = cell.row.original;

      return (
        <div>
          {cell.value ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Image src={constants.IMAGES.CHECK_YELLOW} className="b__image" />
              <div
                style={{
                  marginLeft: '8px',
                }}
              >
                <Table.Link
                  to={`/disaster-notices/answer/detail?id=${detail.id}&notificationId=${detail.notificationId}`}
                  value={`回答詳細`}
                  detail={detail}
                />
              </div>
            </div>
          ) : (
            <Icon.Close />
          )}
        </div>
      );
    },
  },
  {
    Header: () => {
      return (
        <Table.Sort
          value="最終回答日時"
          accessor="replyDatetime"
          updateCurrent={async (nextSort: string, current: number) => {
            setLoading(true);
            await props.actions.notifications.updateCurrentNotificationDetail({
              page: current,
              sort: nextSort,
              notificationId: props.match.params.id,
              isSafe: props.notifications.detail.search.isSafe,
              isMinorInjury: props.notifications.detail.search.isMinorInjury,
              isSeriousInjury:
                props.notifications.detail.search.isSeriousInjury,
              isAnswered: props.notifications.detail.search.isAnswered,
              name: props.notifications.detail.search.names,
              organization: props.notifications.detail.search.organizations,
              position: props.notifications.detail.search.positions,
            });
            setLoading(false);
          }}
          current={props.notifications.detail.pagination.current}
          currentSort={props.notifications.detail.pagination.sort}
        />
      );
    },
    accessor: 'replyDatetime',
    width: 200,
    Cell: ({cell}: {cell: any; column: any}) => {
      return cell.value
        ? utils.date.format(cell.value, 'YYYY/MM/DD HH:mm:ss')
        : '-';
    },
  },
  {
    Header: 'Eメール',
    accessor: 'emailSendStatus',
    width: 120,
    Cell: ({cell}: {cell: any; column: any}) => {
      return (
        <div className="b__result-icon">
          {cell.value === constants.SEND_STATUS.SUCCESS && (
            <span className="c__success_text">送信完了</span>
          )}
          {cell.value === constants.SEND_STATUS.FAILED && (
            <>
              <span className="c__error_text">送信失敗</span>
              <Popup.Normal on="click" basic content={<PopupMessage.Error />} />
            </>
          )}
          {cell.value === constants.SEND_STATUS.PENDING && (
            <span className="c__pending_text">送信中</span>
          )}
          {cell.value === constants.SEND_STATUS.NOT_EXECUTED && (
            <>
              <span className="c__error_text">送信不可</span>
              <Popup.Normal
                on="click"
                basic
                content={<PopupMessage.Pending />}
              />
            </>
          )}
          {!cell.value && '-'}
        </div>
      );
    },
  },
  {
    Header: 'SMS',
    accessor: 'smsSendStatus',
    width: 120,
    Cell: ({cell}: {cell: any; column: any}) => {
      return (
        <div className="b__result-icon">
          {cell.value === constants.SEND_STATUS.SUCCESS && (
            <span className="c__success_text">送信完了</span>
          )}
          {cell.value === constants.SEND_STATUS.FAILED && (
            <>
              <span className="c__error_text">送信失敗</span>
              <Popup.Normal on="click" basic content={<PopupMessage.Error />} />
            </>
          )}
          {cell.value === constants.SEND_STATUS.PENDING && (
            <span className="c__pending_text">送信中</span>
          )}
          {cell.value === constants.SEND_STATUS.NOT_EXECUTED && (
            <>
              <span className="c__error_text">送信不可</span>
              <Popup.Normal
                on="click"
                basic
                content={<PopupMessage.Pending />}
              />
            </>
          )}
          {!cell.value && '-'}
        </div>
      );
    },
  },
  {
    Header: '電話',
    accessor: 'connectSendStatus',
    width: 120,
    Cell: ({cell}: {cell: any; column: any}) => {
      return (
        <div className="b__result-icon">
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            {cell.value === constants.SEND_STATUS.SUCCESS && (
              <span className="c__success_text">送信完了</span>
            )}
            {cell.value === constants.SEND_STATUS.FAILED && (
              <>
                <span className="c__error_text">送信失敗</span>
                <Popup.Normal
                  on="click"
                  basic
                  content={<PopupMessage.Error />}
                />
              </>
            )}
            {cell.value === constants.SEND_STATUS.PENDING && (
              <span className="c__pending_text">送信中</span>
            )}
            {cell.value === constants.SEND_STATUS.NOT_EXECUTED && (
              <>
                <span className="c__error_text">送信不可</span>
                <Popup.Normal
                  on="click"
                  basic
                  content={<PopupMessage.Pending />}
                />
              </>
            )}
            {!cell.value && '-'}
          </div>
        </div>
      );
    },
  },
  {
    Header: '所属組織',
    accessor: 'organization',
    width: 200,
    Cell: ({cell}: {cell: any; column: any}) => {
      return cell.value ? cell.value : '-';
    },
  },
  {
    Header: '役職',
    accessor: 'position',
    width: 200,
    Cell: ({cell}: {cell: any; column: any}) => {
      return cell.value ? cell.value : '-';
    },
  },
  {
    Header: '携帯番号',
    width: 180,
    accessor: 'phoneNumber',
    Cell: ({cell}: {cell: any; column: any}) => {
      return cell.value || '-';
    },
  },
  {
    Header: 'メールアドレス',
    accessor: 'email',
    width: 424,
    Cell: ({cell}: {cell: any; column: any}) => {
      return cell.value || '-';
    },
  },
];
